<div class="row" *ngIf="isBasica">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
      <mat-card class="mat-elevation-z8 w-100">
          <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
              <div class="row">
                  <div class="col-lg col-md col-xs col-xl col-sm">
                      <p class="tituloLeft">{{ step }}</p>
                  </div>
                  <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2
                      text-right">
                      <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                          *ngIf="!collapseCard"></i>
                      <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                          *ngIf="collapseCard"></i>
                  </div>
              </div>
              <mat-card-content *ngIf="!collapseCard">
                  <div class="row">

                      <div class="col-6 pt-3" *ngIf="!isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Peso Amostra
                                  em 30 segundos (g)</mat-label>
                              <input matInput id="txtPesoAmostraTrintaSec" #txtPesoAmostraTrintaSec maxlength="10"
                                  formControlName="peso_amostra_trinta_segundos_g" currencyMask
                                  (blur)="makeCalculations()" />
                              <i matSuffix class="{{ iconEnableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtPesoAmostraTrintaSec.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(
                                  formulario.controls.peso_amostra_trinta_segundos_g
                                  )
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3" *ngIf="!isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Peso da
                                  fração de análise (g)</mat-label>
                              <input matInput id="txtPesoFracaoAnalise" #txtPesoFracaoAnalise maxlength="10"
                                  formControlName="peso_fracao_analise_g" currencyMask (blur)="makeCalculations()" />
                              <i matSuffix class="{{ iconEnableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtPesoFracaoAnalise.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(formulario.controls.peso_fracao_analise_g)
                                  }}</mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3" *ngIf="!isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Peso de
                                  semente boa no descarte (g)</mat-label>
                              <input matInput id="txtPesoSementeBoaDesc" #txtPesoSementeBoaDesc maxlength="10"
                                  formControlName="peso_semente_boa_descarte_g" currencyMask
                                  (blur)="makeCalculations()" [ngClass]="{
                                  InputBlockColor:
                                  formulario.controls.peso_semente_boa_descarte_g.disabled
                                  }" />
                              <i matSuffix class="{{ iconEnableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor"
                                  *ngIf="!formulario.controls.peso_semente_boa_descarte_g.disabled">{{
                                  hintNumber }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtPesoSementeBoaDesc.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(
                                  formulario.controls.peso_semente_boa_descarte_g
                                  )
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Descarte
                                  total da Pré-limpeza (%)</mat-label>
                              <input matInput id="txtDescTotalPreLimp" #txtDescTotalPreLimp maxlength="10"
                                  formControlName="descarte_total_pre_limpeza_prc" currencyMask readonly
                                  class="InputBlockColor" />
                              <i matSuffix class="{{ iconDisableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintCalc
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtDescTotalPreLimp.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(
                                  formulario.controls.descarte_total_pre_limpeza_prc
                                  )
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3" *ngIf="!isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Perda de
                                  Semente boa no Descarte (%)</mat-label>
                              <input matInput id="txtPerdaSemBoaDesc" #txtPerdaSemBoaDesc maxlength="10"
                                  formControlName="perda_semente_boa_descarte_prc" currencyMask readonly
                                  class="InputBlockColor" />
                              <i matSuffix class="{{ iconDisableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintCalc
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtPerdaSemBoaDesc.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(
                                  formulario.controls.perda_semente_boa_descarte_prc
                                  )
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3" *ngIf="!isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Perda no
                                  Descarte (%)</mat-label>
                              <input matInput id="txtPerdaDescPorc" #txtPerdaDescPorc maxlength="10"
                                  formControlName="perda_descarte_prc" currencyMask readonly
                                  class="InputBlockColor" />
                              <i matSuffix class="{{ iconDisableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintCalc
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtPerdaDescPorc.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(formulario.controls.perda_descarte_prc)
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <!--  <div class="col-6 pt-3" *ngIf="!isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Total
                                  Defeitos (g)</mat-label>
                              <input matInput id="txtDef" #txtDef maxlength="10" formControlName="total_defeitos_g"
                                  currencyMask (blur)="makeCalculations()" [ngClass]="{
                                  InputBlockColor:
                                  formulario.controls.total_defeitos_g.disabled
                                  }" />
                              <i matSuffix class="{{ iconEnableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor"
                                  *ngIf="!formulario.controls.total_defeitos_g.disabled">{{
                                  hintNumber }}
                              </mat-hint>
                              <mat-hint align="end">{{ txtDef.value.length }}
                                  / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(formulario.controls.total_defeitos_g)
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3" *ngIf="!isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Total
                                  Defeitos (%)</mat-label>
                              <input matInput id="txtDefPorc" #txtDefPorc maxlength="10"
                                  formControlName="total_defeitos_prc" currencyMask readonly
                                  class="InputBlockColor" />
                              <i matSuffix class="{{ iconDisableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintCalc
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{ txtDefPorc.value.length
                                  }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(formulario.controls.total_defeitos_prc)
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Peso
                                  Hectolítrico Fração Boa (kg/hl)</mat-label>
                              <input matInput id="txtPesoHectoFraBoa" #txtPesoHectoFraBoa maxlength="10"
                                  formControlName="peso_hectolitrico_fracao_boa" currencyMask
                                  (blur)="makeCalculations()" />
                              <i matSuffix class="{{ iconEnableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtPesoHectoFraBoa.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(
                                  formulario.controls.peso_hectolitrico_fracao_boa
                                  )
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Peso
                                  Hectolítrico Fração Descarte (kg/hl)</mat-label>
                              <input matInput id="txtHectoFraDesc" #txtHectoFraDesc maxlength="10"
                                  formControlName="peso_hectolitrico_fracao_descarte" currencyMask
                                  (blur)="makeCalculations()" />
                              <i matSuffix class="{{ iconEnableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtHectoFraDesc.value.length }} / 10</mat-hint>
                              <mat-error>
                                  {{
                                  hasErrorFormControl(
                                  formulario.controls.peso_hectolitrico_fracao_descarte
                                  )
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                    <!--  <div class="col-6 pt-3">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Diferença de
                                  Peso Hectolítrico</mat-label>
                              <input matInput id="txtDifPesoHecto" #txtDifPesoHecto maxlength="10"
                                  formControlName="diferenca_peso_hectolitrico" currencyMask readonly
                                  class="InputBlockColor" />
                              <i matSuffix class="{{ iconDisableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintCalc
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtDifPesoHecto.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(
                                  formulario.controls.diferenca_peso_hectolitrico
                                  )
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div> -->

                      <div class="col-6 pt-3" *ngIf="isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Peso pré + pós-sucção em 60 segundos (g)</mat-label>
                              <input matInput id="txtpesoPrePosSuccsao" #txtpesoPrePosSuccsao
                                  formControlName="peso_pre_pos_succsao" currencyMask maxlength="10" />
                              <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                              </mat-hint>
                              <mat-hint align="end">{{txtpesoPrePosSuccsao.value.length }} / 10</mat-hint>
                              <mat-error>
                                  {{hasErrorFormControl(formulario.controls.peso_pre_pos_succsao)}}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3" *ngIf="isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Peso topo e fundo em 30 segundos (g)</mat-label>
                              <input matInput id="txtPesoTopoFundo30s" #txtPesoTopoFundo30s
                                  formControlName="peso_topo_fundo_30s" currencyMask maxlength="10"
                                  (blur)="makeCalculations()" />
                              <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                              </mat-hint>
                              <mat-hint align="end">{{txtPesoTopoFundo30s.value.length }} / 10</mat-hint>
                              <mat-error>
                                  {{hasErrorFormControl(formulario.controls.peso_topo_fundo_30s)}}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3" *ngIf="isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Descarte (kg/h)</mat-label>
                              <input matInput id="txtDescarteKgH" #txtDescarteKgH formControlName="descarte_kg_h"
                                  currencyMask maxlength="10" readonly class="InputBlockColor" />
                              <i matSuffix class="{{ iconDisableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                              <mat-hint align="end">{{txtDescarteKgH.value.length }} / 10</mat-hint>
                              <mat-error>
                                  {{hasErrorFormControl(formulario.controls.descarte_kg_h)}}
                              </mat-error>
                          </mat-form-field>
                      </div>

                  </div>
              </mat-card-content>
          </form>
      </mat-card>
  </div>
</div>

<div class="row" *ngIf="isComercial">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
      <mat-card class="mat-elevation-z8 w-100">
          <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
              <div class="row">
                  <div class="col-lg col-md col-xs col-xl col-sm">
                      <p class="tituloLeft">{{ step }}</p>
                  </div>
                  <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2
                      text-right">
                      <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                          *ngIf="!collapseCard"></i>
                      <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                          *ngIf="collapseCard"></i>
                  </div>
              </div>
              <mat-card-content *ngIf="!collapseCard">
                  <div class="row">

                      <div class="col-6 pt-3" *ngIf="!isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Peso Amostra
                                  em 30 segundos (g)</mat-label>
                              <input matInput id="txtPesoAmostraTrintaSec" #txtPesoAmostraTrintaSec maxlength="10"
                                  formControlName="peso_amostra_trinta_segundos_g" currencyMask
                                  (blur)="makeCalculations()" />
                              <i matSuffix class="{{ iconEnableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtPesoAmostraTrintaSec.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(
                                  formulario.controls.peso_amostra_trinta_segundos_g
                                  )
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3" *ngIf="!isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Peso da
                                  fração de análise (g)</mat-label>
                              <input matInput id="txtPesoFracaoAnalise" #txtPesoFracaoAnalise maxlength="10"
                                  formControlName="peso_fracao_analise_g" currencyMask (blur)="makeCalculations()" />
                              <i matSuffix class="{{ iconEnableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtPesoFracaoAnalise.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(formulario.controls.peso_fracao_analise_g)
                                  }}</mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3" *ngIf="!isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Peso de
                                  semente boa no descarte (g)</mat-label>
                              <input matInput id="txtPesoSementeBoaDesc" #txtPesoSementeBoaDesc maxlength="10"
                                  formControlName="peso_semente_boa_descarte_g" currencyMask
                                  (blur)="makeCalculations()" [ngClass]="{
                                  InputBlockColor:
                                  formulario.controls.peso_semente_boa_descarte_g.disabled
                                  }" />
                              <i matSuffix class="{{ iconEnableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor"
                                  *ngIf="!formulario.controls.peso_semente_boa_descarte_g.disabled">{{
                                  hintNumber }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtPesoSementeBoaDesc.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(
                                  formulario.controls.peso_semente_boa_descarte_g
                                  )
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Descarte
                                  total da Pré-limpeza (%)</mat-label>
                              <input matInput id="txtDescTotalPreLimp" #txtDescTotalPreLimp maxlength="10"
                                  formControlName="descarte_total_pre_limpeza_prc" currencyMask readonly
                                  class="InputBlockColor" />
                              <i matSuffix class="{{ iconDisableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintCalc
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtDescTotalPreLimp.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(
                                  formulario.controls.descarte_total_pre_limpeza_prc
                                  )
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3" *ngIf="!isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Perda de
                                  Semente boa no Descarte (%)</mat-label>
                              <input matInput id="txtPerdaSemBoaDesc" #txtPerdaSemBoaDesc maxlength="10"
                                  formControlName="perda_semente_boa_descarte_prc" currencyMask readonly
                                  class="InputBlockColor" />
                              <i matSuffix class="{{ iconDisableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintCalc
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtPerdaSemBoaDesc.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(
                                  formulario.controls.perda_semente_boa_descarte_prc
                                  )
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3" *ngIf="!isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Perda no
                                  Descarte (%)</mat-label>
                              <input matInput id="txtPerdaDescPorc" #txtPerdaDescPorc maxlength="10"
                                  formControlName="perda_descarte_prc" currencyMask readonly
                                  class="InputBlockColor" />
                              <i matSuffix class="{{ iconDisableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintCalc
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtPerdaDescPorc.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(formulario.controls.perda_descarte_prc)
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <!--  <div class="col-6 pt-3" *ngIf="!isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Total
                                  Defeitos (g)</mat-label>
                              <input matInput id="txtDef" #txtDef maxlength="10" formControlName="total_defeitos_g"
                                  currencyMask (blur)="makeCalculations()" [ngClass]="{
                                  InputBlockColor:
                                  formulario.controls.total_defeitos_g.disabled
                                  }" />
                              <i matSuffix class="{{ iconEnableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor"
                                  *ngIf="!formulario.controls.total_defeitos_g.disabled">{{
                                  hintNumber }}
                              </mat-hint>
                              <mat-hint align="end">{{ txtDef.value.length }}
                                  / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(formulario.controls.total_defeitos_g)
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3" *ngIf="!isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Total
                                  Defeitos (%)</mat-label>
                              <input matInput id="txtDefPorc" #txtDefPorc maxlength="10"
                                  formControlName="total_defeitos_prc" currencyMask readonly
                                  class="InputBlockColor" />
                              <i matSuffix class="{{ iconDisableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintCalc
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{ txtDefPorc.value.length
                                  }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(formulario.controls.total_defeitos_prc)
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Peso
                                  Hectolítrico Fração Boa (kg/hl)</mat-label>
                              <input matInput id="txtPesoHectoFraBoa" #txtPesoHectoFraBoa maxlength="10"
                                  formControlName="peso_hectolitrico_fracao_boa" currencyMask
                                  (blur)="makeCalculations()" />
                              <i matSuffix class="{{ iconEnableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtPesoHectoFraBoa.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(
                                  formulario.controls.peso_hectolitrico_fracao_boa
                                  )
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Peso
                                  Hectolítrico Fração Descarte (kg/hl)</mat-label>
                              <input matInput id="txtHectoFraDesc" #txtHectoFraDesc maxlength="10"
                                  formControlName="peso_hectolitrico_fracao_descarte" currencyMask
                                  (blur)="makeCalculations()" />
                              <i matSuffix class="{{ iconEnableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtHectoFraDesc.value.length }} / 10</mat-hint>
                              <mat-error>
                                  {{
                                  hasErrorFormControl(
                                  formulario.controls.peso_hectolitrico_fracao_descarte
                                  )
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div>

                    <!--  <div class="col-6 pt-3">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Diferença de
                                  Peso Hectolítrico</mat-label>
                              <input matInput id="txtDifPesoHecto" #txtDifPesoHecto maxlength="10"
                                  formControlName="diferenca_peso_hectolitrico" currencyMask readonly
                                  class="InputBlockColor" />
                              <i matSuffix class="{{ iconDisableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{ hintCalc
                                  }}
                              </mat-hint>
                              <mat-hint align="end">{{
                                  txtDifPesoHecto.value.length }} / 10</mat-hint>
                              <mat-error>{{
                                  hasErrorFormControl(
                                  formulario.controls.diferenca_peso_hectolitrico
                                  )
                                  }}
                              </mat-error>
                          </mat-form-field>
                      </div> -->

                      <div class="col-6 pt-3" *ngIf="isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Peso pré + pós-sucção em 60 segundos (g)</mat-label>
                              <input matInput id="txtpesoPrePosSuccsao" #txtpesoPrePosSuccsao
                                  formControlName="peso_pre_pos_succsao" currencyMask maxlength="10" />
                              <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                              </mat-hint>
                              <mat-hint align="end">{{txtpesoPrePosSuccsao.value.length }} / 10</mat-hint>
                              <mat-error>
                                  {{hasErrorFormControl(formulario.controls.peso_pre_pos_succsao)}}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3" *ngIf="isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Peso topo e fundo em 30 segundos (g)</mat-label>
                              <input matInput id="txtPesoTopoFundo30s" #txtPesoTopoFundo30s
                                  formControlName="peso_topo_fundo_30s" currencyMask maxlength="10"
                                  (blur)="makeCalculations()" />
                              <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                              </mat-hint>
                              <mat-hint align="end">{{txtPesoTopoFundo30s.value.length }} / 10</mat-hint>
                              <mat-error>
                                  {{hasErrorFormControl(formulario.controls.peso_topo_fundo_30s)}}
                              </mat-error>
                          </mat-form-field>
                      </div>

                      <div class="col-6 pt-3" *ngIf="isBasic">
                          <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Descarte (kg/h)</mat-label>
                              <input matInput id="txtDescarteKgH" #txtDescarteKgH formControlName="descarte_kg_h"
                                  currencyMask maxlength="10" readonly class="InputBlockColor" />
                              <i matSuffix class="{{ iconDisableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                              <mat-hint align="end">{{txtDescarteKgH.value.length }} / 10</mat-hint>
                              <mat-error>
                                  {{hasErrorFormControl(formulario.controls.descarte_kg_h)}}
                              </mat-error>
                          </mat-form-field>
                      </div>

                  </div>
              </mat-card-content>
          </form>
      </mat-card>
  </div>
</div>